export const constants = {
    imageWidth: 1500,
    imageHeight: 1500,
}

export function getYouTubeId(url: string): string | null {
    if (!url) return null;
    const patterns = [
        /(?:youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/,
        /(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
        /(?:youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
        /(?:youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    ];
    for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match) return match[1];
    }
    return null;
}

/**
 * Embed URL for a click-to-play YouTube video.
 *
 * YouTube draws its own title bar, channel name and share / watch-later buttons
 * over the player and there is no parameter to turn those off — that chrome is
 * the price of the view counting on YouTube. `rel=0` is the one lever that still
 * works: it keeps the end-screen suggestions to the same channel.
 */
export function youTubeEmbedUrl(videoId: string) {
    const params = [
        `autoplay=1`,
        `rel=0`, // end-screen suggestions stay on the same channel
        `playsinline=1`, // no forced fullscreen takeover on iOS
    ].join(`&`)
    return `https://www.youtube-nocookie.com/embed/${videoId}?${params}`
}
